import { z } from 'zod';
/**
 * Activation status of this zone definition.
 */
export var DefinitionStatus;
(function (DefinitionStatus) {
    DefinitionStatus["Active"] = "active";
    DefinitionStatus["Inactive"] = "inactive";
})(DefinitionStatus || (DefinitionStatus = {}));
export const DefinitionStatusSchema = z.nativeEnum(DefinitionStatus);
export var ConfigurationStatus;
(function (ConfigurationStatus) {
    ConfigurationStatus["Draft"] = "draft";
    ConfigurationStatus["Staged"] = "staged";
    ConfigurationStatus["Published"] = "published";
    ConfigurationStatus["Unpublished"] = "unpublished";
    ConfigurationStatus["Deleted"] = "deleted";
    ConfigurationStatus["Revision"] = "revision";
})(ConfigurationStatus || (ConfigurationStatus = {}));
export const ConfigurationStatusSchema = z.nativeEnum(ConfigurationStatus);
//# sourceMappingURL=status.js.map